/**
 * @fileOverview This file contains the implementation of the AgendaNoRowsOverlay component
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region  Imports
import { Box } from "@mui/system";
import { GridOverlay } from "@mui/x-data-grid-pro";
import { useTranslationHook } from "../../hooks/UseTranslationHook";
//#endregion

const AgendaNoRowsOverlay = () => {
  const { agendaNoData } = useTranslationHook();
  return (
    <GridOverlay>
      <Box>{agendaNoData}</Box>
    </GridOverlay>
  );
};

export default AgendaNoRowsOverlay;
